import { gql } from "@apollo/client";

export const LOADOUT_QUERY = gql`
  query Loadouts($game: Int!, $type: String!) {
    loadouts(game: $game, type: $type) {
      _id
      name
      description
      image
      cards {
        _id
      }
    }
  }
`;

const PLAYER_USER_FIELDS = gql`
  fragment PlayerUserFragment on User {
    _id
    username
  }
`;

export const ME_QUERY = gql`
  query Me {
    me {
      mediaUploadUrl(type: JPEG) {
        fields {
          name
          value
        }
        key
        url
      }
    }
  }
`;

export const QUICK_EDIT_IN_CAMPAIGN = gql`
  query QuickEditInCampaign($campaign: String) {
    inCampaign(campaign: $campaign) {
      exists
      progress
    }
  }
`;

export const QUICK_EDIT_GET_MOMENT = gql`
  ${PLAYER_USER_FIELDS}
  query QuickEditGetMoment($id: String!) {
    moment(id: $id) {
      id
      title
      timelineLabel
      game
      type
      match {
        id
        matchPlayedAt
        hero
      }
      victimData {
        team
        gameId
        displayName
        avatar
        user {
          ...PlayerUserFragment @nonreactive
        }
      }
      clip {
        id
      }
      icons
      displayTags {
        key
        value
      }
      clipTags {
        key
        value
      }
      player {
        avatar
        displayName
        gameId
        team
        user {
          ...PlayerUserFragment @nonreactive
        }
      }
    }
  }
`;

export const THUMBNAIL_QUERY = gql`
  query ThumbnailCards($type: [String], $getUserCards: Boolean) {
    facets(type: $type, getUserCards: $getUserCards) {
      cards {
        _id
        userActivated
        scopeUse
        ui {
          image
          title
        }
        cc {
          thumbnailPresetId
        }
      }
    }
  }
`;

export const GET_LOADOUTS = gql`
  query GetLoadouts($game: Int) {
    loadouts(game: $game) {
      name
    }
  }
`;

export const GET_MY_SIGNATURE_QUICK_EDIT = gql`
  query GetMySignatureQuickEditQuery($user: String!, $signature: Boolean) {
    getLoadouts(user: $user, signature: $signature) {
      _id
      metadataCustomStyleSelection {
        metadataStyleName
        settingsUiToggleName
      }
      clipCards {
        enabled
        card {
          _id
          effect
        }
      }
    }
  }
`;

export const THUMBNAIL_PREVIEW = gql`
  query ThumbnailPreview(
    $args: JSON!
    $type: ThumbnailPreset
    $presetObjId: String
  ) {
    thumbnailPreview(args: $args, type: $type, presetObjId: $presetObjId)
  }
`;

export const GET_USER_CLIP_ELIGIBILITY = gql`
  query GetUserClipEligibility($userId: String!) {
    getUserClipEligibility(userId: $userId) {
      errors {
        field
        code
        message
      }
      success
      reason
      isEligible
      canCreateClipAt
    }
  }
`;
